'use strict';
import React from 'react';
import t from 'tcomb-form';
import flux from 'utils/flux';
import keybinding from 'react-keybinding';

var Form = t.form.Form;
var BasketTitleForm = t.struct({
    name: t.Str
});

var BasketTitle = React.createClass({
    displayName: 'BasketTitle',
    mixins: [
        keybinding
    ],
    propTypes: {
        name: React.PropTypes.string.isRequired,
        basketId: React.PropTypes.string.isRequired
    },
    keybindings: {
        'esc': function() {
            this.setState({editMode: false});
        }
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.name !== this.props.name) {
            this.setState({editMode: false, name: nextProps.name});
        }
    },
    getInitialState() {
        return {
            editMode: false,
            name: this.props.name
        };
    },
    onSubmit(e) {
        e.preventDefault();
        var data = this.refs.form.getValue();
        if (data) {
            if (data.name === this.props.name) {
                this.setState({editMode: false});
            } else {
                flux.getStore('basket').editBasketName(this.props.basketId, data.name).then(() => {
                    this.setState({editMode: false});
                });
            }
        }
    },
    toggleEdit(e) {
        e.preventDefault();
        this.setState({editMode: !this.state.editMode});
    },
    onChange(value) {
        this.setState({name: value.name});
    },
    renderTitle() {
        var options = {
            auto: 'placeholders',
            fields: {
                name: {
                    attrs: {
                        autoFocus: true
                    }
                }
            }
        };

        if (this.state.editMode) {
            return (
                <div className="title__edit">
                    <div className="edit__submit">
                        <a href="#" role="button" onClick={this.onSubmit}><i className="gopro-pencil" /></a>
                    </div>
                    <form onSubmit={this.onSubmit}>
                        <Form
                          ref="form"
                          type={BasketTitleForm}
                          options={options}
                          value={this.state}
                          onChange={this.onChange}
                        />
                    </form>
                    <div className="edit__close">
                        <a href="#" onClick={this.toggleEdit}></a>
                    </div>
                </div>
            );
        } else {
            return <h4><a href="#" onClick={this.toggleEdit}><i className="gopro-pencil" /></a> {this.props.name}</h4>;
        }
    },
    render() {
        return (
            <div className="basket__title">
                {this.renderTitle()}
            </div>);
    }
});

module.exports = BasketTitle;



// WEBPACK FOOTER //
// ./app/pages/basket/basketTitle.jsx